import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { PersonalHistory } from './PersonalHistory';
import { Assumptions } from '../static/Assumptions';
import { Customer } from './Customer';
import { Surgery as GQLSurgery } from '@hit/hit-api-client';

@supertypeClass({ toClient: true, toServer: true })
export class Surgery extends Everything implements GQLSurgery {
  @property()
  type: string = '';

  @property({ getType: () => PersonalHistory })
  personalHistory: PersonalHistory;

  @property({ rule: ['required', 'text'], validate: 'isNotEmptyAndMinLength(2)' })
  description: string = '';

  @property({ rule: ['required', 'text'], validate: 'isNotEmptyAndMinLength(2)' })
  physician: string = '';

  @property({ rule: ['required', 'shortdate'] })
  date: Date = null;

  @property({ rule: ['required', 'geoName'], validate: 'isNotEmptyAndMinLength(2); isMaxLength(86)' })
  city: string = '';

  @property({ rule: ['required'], values: Assumptions.stateValues })
  state: string = '';

  @property({ role: ['required', 'text'], validate: 'isNotEmptyAndMinLength(2); isNotEmptyAndMaxLength(250)' })
  details: string = '';

  @property({ isLocal: true })
  stateValues = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    MS: 'Mississippi',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
    __name__: 'Assumptions.stateValues',
  };

  @property({ getType: () => Customer })
  customer: Customer;

  constructor() {
    super();
  }

  static new(customer) {
    return new Surgery().init(customer);
  }

  init(customer) {
    this.customer = customer;
    return this;
  }
}
